<div class="free-guides" *ngIf="isDataStudentComplete">
  <div class="free-guides-container">
    <div class="free-guides-right">
      <img
        (click)="goBack()"
        class="left-arrow display-mobile"
        src="/assets/wizard-images/left-arrow.png"
        alt="left-arrow" />
      <h2 class="free-guides-subtitle">
        Tu potencial es ilimitado. Participa en nuestro test de competencias y desbloquea las habilidades que te
        llevarán a la cima de tus objetivos.
      </h2>
      <h1 class="free-guides-title">¡Anímate y realiza nuestro test!</h1>
      <div class="row">
        <div class="col-1">
          <img
            *ngIf="seleccionado == 0"
            (click)="cambiarSeleccionado()"
            style="height: auto; width: 20px"
            src="/assets/utils/radio-boton-gris-vacio.png"
            alt="acepta" />
          <img
            *ngIf="seleccionado == 1"
            style="height: auto; width: 20px"
            src="/assets/utils/radio-boton-gris-lleno.png"
            alt="acepta" />
        </div>

        <div class="col-10">
          <p class="conditions">
            Acepto los
            <span class="negrilla">términos y condiciones y politica de privacidad</span>
          </p>
        </div>
      </div>
      <div class="buttons-container">
        <button class="btnComenzar" (click)="comenzarTest()">Empezar test</button>
      </div>
    </div>
  </div>
</div>
<div class="d-flex mt-3 mt-lg-5 withoutSkillTestMessage" *ngIf="!isDataStudentComplete">
  <div>
    <label class="about-me-title txt-style mb-2 mb-lg-4">
      ¡No has completado toda tu información! ¡Completa toda tu información para realizar el test!
    </label>
  </div>
  <button class="btn-experiences" (click)="goToPersonalInfo()">Completar</button>
</div>
